<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Servicios</h4>
    <hr />

    <DataTable
      :data="servicios"
      :columns="[{ label: 'Nombre', field: 'nombre' }]"
      idField="idServicio"
      mensajeVacio="No hay registros de servicios."
      :mostrarBotonNuevo="idPerfil == 1"
      :mostrarEditar="idPerfil == 1"
      :mostrarVer="false"
      :mostrarEliminar="idPerfil == 1"
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idServicio)"
      @delete="row => deleteServicio(row.idServicio)"
    />

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- ID solo en edición -->
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoServicio.idServicio" disabled />
                </div>
              </div>
            </div>
            <!-- Nombre -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoServicio.nombre"
                    style="text-transform:uppercase"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarServicio"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarServicio"
              v-if=" btnEditar && esAdmin "
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      servicios:    [],
      datoServicio: {},
      titulo:       "",
      btnCrear:     false,
      btnEditar:    false,
      modalWindow:  true,
      idPerfil:     0,
    };
  },
  computed: {
    esAdmin() {
      const idPerfil = Number(window.sessionStorage.getItem("idPerfil"));
      return idPerfil === 1;
    }
  },
  mounted() {
    this.idPerfil = Number(window.sessionStorage.getItem("idPerfil"));
    this.getDataPaginaTodos();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    getDataPaginaTodos() {
      api.get("/vwservicios")
        .then(r => { this.servicios = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar servicios:", e));
    },
    validarForm() {
      return validarForm(this.datoServicio, ["nombre"], ["nombre"]);
    },
    async guardarServicio() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/servicios", this.datoServicio);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Servicio creado exitosamente." });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async actualizarServicio() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/servicios", this.datoServicio);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Servicio actualizado exitosamente." });
        this.getDataPaginaTodos();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    async deleteServicio(idServicio) {
      const confirm = await Swal.fire({
        title: "¿Eliminar registro?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/servicios/" + idServicio);
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoServicio = {};
      this.titulo       = "Crear Servicio";
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    async abrirModalEditar(idServicio) {
      this.modalWindow = true;
      this.titulo      = "Editar Servicio";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp        = await api.get("/vwservicios/" + idServicio);
        this.datoServicio = resp.data;
      } catch (e) {
        console.error("Error al cargar servicio:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
  },
};
</script>